module.exports = __webpack_public_path__ + "static/media/kor_2.d5335ee0.jpg";